import { render, staticRenderFns } from "./SettingMenuSidebar.vue?vue&type=template&id=e713d1c0&scoped=true&"
import script from "./SettingMenuSidebar.vue?vue&type=script&lang=js&"
export * from "./SettingMenuSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SettingMenuSidebar.vue?vue&type=style&index=0&id=e713d1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e713d1c0",
  null
  
)

export default component.exports